import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Nav from '../HomePage/Nav';
import Footer from '../HomePage/Footer';
import BlueNav from '../HomePage/BlueNav';
import Seo from '../Seo/Seo';
import { toMetaDescription, useCanonicalUrl } from '../Seo/seoUtils';
import { buildBlogJsonLd } from '../Seo/jsonLd';
import { SITE_NAME } from '../Seo/seoConfig';

const BlogInner = () => {
  const { Id } = useParams(); // Get the Id parameter from the URL
  const [blog, setBlog] = useState(null); // State to store the fetched blog details
  const canonicalUrl = useCanonicalUrl();

  useEffect(() => {
    // Clear the previous post's data so its title/description/JSON-LD don't
    // stay in the document head while navigating straight from one blog
    // post to another (BlogDetails has no per-post id field to compare
    // against, so a stale-state guard like PackageDestination's isn't
    // possible here - resetting on Id change is the safe equivalent).
    setBlog(null);
    const fetchBlogDetails = async () => {
        try {
          const response = await fetch(`https://api.travellerchoiceladakh.com/api/BlogDetails/${Id}`);
          const data = await response.json();
      
          if (data.status === "true" && data.data) {
            setBlog(data.data); // Set the fetched blog details to the state
            console.log("inner-",blog );
          } else {
            console.error('Error fetching blog details: Invalid response data');
          }
        } catch (error) {
          console.error('Error fetching blog details:', error);
        }
      };

    fetchBlogDetails();
  }, [Id]);
  
  console.log("idd-",Id);

  return (
    <>
      <Seo
        title={blog ? `${blog.Title} | ${SITE_NAME}` : undefined}
        description={blog ? toMetaDescription(blog.LongDescription, 160) : undefined}
        image={blog?.Image}
        type="article"
        jsonLd={blog ? buildBlogJsonLd(blog, canonicalUrl) : null}
      />
      {blog ? (
        <div className='container-fluid'>
          <Nav/>
          <div
            className="container-fluid p-0 position-relative mb-5"
            style={{
              backgroundImage: `url(${blog.Image})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              minHeight: "60vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-end", // Align items to the bottom
              position: "relative",
            }}
          >
            {/* Overlay text */}
            <div className="overlay-text" style={{ position: 'absolute' }}>
              <h2 style={{ color: "#FFFFFF" }}>
                <b>{blog.Title}</b>
              </h2>
              <p style={{ marginTop: "2rem", color: "#FFFFFF" }}>by <b><span style={{color:"#FFA902"}} >{blog.Post}</span></b></p>
            </div>
          </div>
          <div className='container'
        dangerouslySetInnerHTML={{ __html: blog.LongDescription }}
      ></div>
        </div>
      ) : (
        <p>Loading...</p>
      )}
      <Footer/>
    </>
  );
};

export default BlogInner;
